import InvitesTab from "./sub_tabs/InvitesTab";
import { SeasonsTab } from "./sub_tabs/SeasonsTab";

const manageShowsTabRouter = {

  invites: 
  {
    title: 'Invites',
    element: <InvitesTab />
  },

  seasons: 
  {
    title: 'Seasons',
    element: <SeasonsTab />
  }

}

export default manageShowsTabRouter;